module.exports = __webpack_public_path__ + "img/icon-fluct.c40f0eea.svg";